import useServiceWorker from '../../assets/javascripts/configuration.js.erb';
const DOCS = 'pdf-v0'; // Make sure this lines up with service_worker

// TODO: Online behaviour.
export default class YourResearch extends BaseComponent {
    initialize() {
        this.find('.document-select').change(element =>
            this.loadPdf($(element.target).find(':selected')));
        if (useServiceWorker) {
            this.populateFromCache();
        }
    }

    async populateFromCache() {
        let cache = await caches.open(DOCS);
        let keys = await cache.keys();
        let select = this.find('.document-select');
        keys.forEach(async key => {
            let title = await (await cache.match(key)).headers.get('Document-Title')
            select.append(`
                <option data-url=${key.url} class="offline-only">${title}</option>
            `.trim());
        });
    }

    loadPdf(element) {
        this.find('.viewer').removeClass('hidden');
        _functions.loadPdf(element.attr('data-url'));
    }
}
